module.exports = __webpack_public_path__ + "img/u12.237f0d09.jpg";